import React from 'react';
import { Intervention } from 'utils/types';
import css from './InterventionView.scss';
import commonCss from './Common.scss';
import { List, Item, Icon } from 'semantic-ui-react';

export default class InterventionView extends React.Component {

  constructor() {
    super();
    this.state = { showDescription: false };
    this.handleItemClick = this.handleItemClick.bind(this);
  }

  handleItemClick() {
    this.setState(prevState => ({ showDescription: !prevState.showDescription }));
  }

  get openIconName() {
    return this.state.showDescription ? 'caret down' : 'caret right';
  }

  get openChildrenIconClass() {
    return this.hasChildren ?  'icon-btn' : 'hidden-icon-btn';
  }

  get descriptionClass() {
    return this.state.showDescription ? 'revealed' : 'hidden';
  }

  get hasChildren() {
    return this.props.intervention.description !== null && this.props.intervention.description !== "";
  }

  render() {
    return (
      <List.Item className={css['child-item']}>
        <Item>
          <Item.Content>
            <Icon size="small"
                  className={css[this.openChildrenIconClass]}
                  name={this.openIconName}
                  onClick={this.handleItemClick} />
            <Item.Header as='a' className={commonCss['button-link']} onClick={this.handleItemClick} >
              {this.props.intervention.shortTitle}
            </Item.Header>
            <Item.Description className={css[this.descriptionClass]}>
              {this.props.intervention.description}
            </Item.Description>
          </Item.Content>
        </Item>
      </List.Item>
    );
  }
}

InterventionView.propTypes = {
  intervention: Intervention.isRequired
};
